module.exports = __webpack_public_path__ + "img/chiffre-2.4040e7c7.svg";